
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getSmsRecordList } from '@/api/product/smsManage'
import {
  dateNotTimezone,
  getCurrentDate,
  pickerOptions
} from '@/utils/dateTime'

@Component({
  name: 'smsLog',
  components: {}
})
export default class extends Vue {
  private queryForm: any = {
    send_mobile: '',
    sms_id: '',
    start_time: '',
    end_time: '',
    send_state: '',
    delivery_status: ''
  }

  private total = 0
  private logList: any = []
  private listLoading: boolean = false
  private date: any[] = getCurrentDate()
  private pickerOptions = pickerOptions

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateNotTimezone(this.date[0])
      this.queryForm.end_time = dateNotTimezone(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.getSmsRecordList()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.getSmsRecordList()
  }

  // 短信记录列表
  private getSmsRecordList() {
    try {
      this.listLoading = true
      this.logList = []
      let data = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      getSmsRecordList(data).then((res: any) => {
        this.total = res.count
        this.logList = res.results
        this.listLoading = false
      })
    } catch (error) {
      this.listLoading = false
    }
  }

  private select() {
    this.getSmsRecordList()
  }

  private reset() {
    this.queryForm.merchant_no = ''
    this.queryForm.sms_id = ''
    this.date = getCurrentDate()
    this.getSmsRecordList()
  }

  mounted() {
    this.getSmsRecordList()
  }
}
